import { useIsAbove, BreakpointName } from "../../../../MediaQuery/MediaQuery/MediaQueryContext.js";
const useDrawerDirection = () => {
  const isBigScreen = useIsAbove(BreakpointName.TABLET_PORTRAIT);
  const drawerDirection = isBigScreen ? "right" : "bottom";
  return drawerDirection;
};
export {
  useDrawerDirection
};
//# sourceMappingURL=use-drawer-direction.js.map
